
// Vue reactivity
import { ref, defineComponent, computed, watch, reactive, onMounted } from 'vue';

// icons
import { add, close, } from 'ionicons/icons';

// components
import { IonPage, IonHeader, IonToolbar, IonContent, IonGrid, IonSegment, IonSegmentButton } from '@ionic/vue';
import TeacherAchieveJUPASModal from '@/components/achievejupas/TeacherAchieveJUPASModal.vue';
import AchieveJUPASResultPageModal from '@/components/achievejupas/AchieveJUPASResultPageModal.vue';

// composables / services
import { useI18n } from 'vue-i18n';
import { utils } from '@/composables/utils';
import { useStore } from '@/store';

export default {
  components: { IonPage, IonHeader, IonToolbar, IonContent, IonGrid, IonSegment, IonSegmentButton,
                TeacherAchieveJUPASModal, AchieveJUPASResultPageModal, },
  setup(props) {
    const { t } = useI18n();
    const store = useStore();
    const selectedView = ref('teacher');

    return {
      selectedView,
    }
  }
};
